// React
import React, { useState, useEffect } from "react";
import { BeatLoader } from "react-spinners";

// Kendo
import kendo from "@progress/kendo-ui";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import koMessage from "../../../com/ko-language.json";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Upload } from "@progress/kendo-react-upload";
import { IntlProvider, LocalizationProvider, loadMessages } from "@progress/kendo-react-intl";

// Css
import "./elderMngt.css";
import styles from "./elderMngt.module.css";

// Service
import { getElderDataListByTest } from "../../../service/mngt/elderService_test";
import { getElderDataList, setDeleteElder, setUpdateElder, setUserInsert, setUserUpdate } from "../../../service/mngt/elderService";
import { getUser } from "../../../service/authService";
import { getAllManagerList } from "../../../service/mngt/managerService";
import { deleteDeviceData, insertDeviceData } from "../../../service/mngt/device/deviceCtrl";
import { Create, Delete, Photo, PhotoCamera, Person, LocalHospital, AccessTime } from "@material-ui/icons";

// Filter
import CustomFilter from "../../com/gridFilter/custom_filter";
import GridColumnInputFilter from "../../com/gridFilter/gridColumnInputFilter";

// Translate
import ElderInfo from "./elderInfo";
import ElderPhoto from "./elderPhoto";
import ElderBehavior from "./elderBehavior";
import ElderAddress from "./elderAddress";
import { parseDate } from "../../../com/dateUtil";
import { downloadExcel } from "../../../com/downloadExcel";
import { faSlack } from "@fortawesome/free-brands-svg-icons";
import ElderDisease from "./elderDisease";
loadMessages(koMessage, "ko-KR");

const ElderMngt = ({ conn, codeList, rgnList, dongList }) => {
  const loginInfo = getUser();
  /* -------------------------------------------------------------- useState 및 변수  */
  // 테스트 여부 플래그
  const isTest = "N";
  const [loading, setLoading] = useState(false);

  // 페이저
  const [pager, setPager] = useState({
    total: 0,
    skip: 0,
    take: 20,
    cid: "",
    userTerm: "",
    rgnCode: getUser().rgnCode,
    dongCode: "",
    managerId: "",
  });
  const [managerList, setManagerList] = useState([]);
  // 담당자 리스트
  const [elderList, setElderList] = useState([]);

  // 담당자 정보 Dialog
  const [elderInfo, setElderInfo] = useState({
    visible: false,
    isNew: false,
    photoInfo: false,
    behaviorInfo: false,
    behaviorAddInfo: false,
    behaviorEditInfo: false,
    diseaseInfo: false,
    diseaseAddInfo: false,
    diseaseEditInfo: faSlack,
    selectedRow: null,
    dataItem: {},
    addressInfo: false,
  });

  /* -------------------------------------------------------------- service 및 데이터 조회  */
  /* 대상자 조회 */
  const getElderList = () => {
    if (isTest === "Y") {
      getElderDataListByTest(conn, getElderResultList, getRejection, pager);
    } else {
      setLoading(true);
      getElderDataList(conn, getElderResultList, getRejection, pager, setLoading);
    }
  };

  // 조회 callback
  const getElderResultList = result => {
    pager.total = result.total;
    setElderList(result.results);
  };

  // 공용 rejection
  const getRejection = reject => {
    console.log("getRejection = ", reject);
  };

  /* 매니저 전체 조회 */
  const getManagerList = () => {
    getAllManagerList(conn)
      .then(response => {
        setManagerList(response);
      })
      .catch(error => {
        console.log("getAllManagerList Error", error);
      });
  };

  /* -------------------------------------------------------------- changeEvent clickEvent  */

  // 행동패턴 버튼
  const isBehaviorBtn = dataItem => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.behaviorInfo = true;
      item.dataItem = dataItem;
      return item;
    });
  }

  // 보유지병 버튼
  const isDiseaseBtn = dataItem => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.diseaseInfo = true;
      item.dataItem = dataItem;
      return item;
    });
  }

  // 수정 버튼
  const isEditEvtBtn = dataItem => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.visible = true;
      item.isNew = false;
      item.dataItem = dataItem;
      return item;
    });
  };

  // 삭제 버튼
  const isDeletedBtn = dataItem => {
    // const {userId} = props.dataItem;
    // 삭제 여부 확인
    kendo
    .confirm(dataItem.userTerm + " 대상자를 삭제 하시겠습니까?")
    .then(e => {
      if(dataItem.bizType === "5003" && dataItem.imei) {
        deleteDeviceData(conn, dataItem);
      } 
        setDeleteElder(conn, dataItem.userId)
          .then(() => {
            kendo.alert(dataItem.userTerm + " 대상자가 삭제되었습니다.");
            getElderList();
          })
          .catch(error => {
            console.log("대상자 삭제 오류");
          });
      })
      .catch(e => {
        kendo.alert("삭제 취소 하였습니다.");
        return;
      });
  };

  // 사진 버튼
  const isPhotoBtn = dataItem => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.photoInfo = true;
      item.dataItem = dataItem;
      return item;
    });
  };

  // 추가 버튼 이벤트
  const addRowEvtBtn = () => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.visible = true;
      item.isNew = true;
      return item;
    });
  };

  // 엑셀업로드 버튼 이벤트
  const excelUploadEvtBtn = () => {
    console.log("엑셀업로드 버튼");
  };

  // 엑셀샘플 다운로드 버튼 이벤트
  const excelSampleEvtBtn = () => {
    console.log("엑셀샘플 다운로드 버튼");
  };

  // 엑셀 저장 버튼 이벤트
  const excelDownEvtBtn = () => {
    setLoading(true);
    const fileName = "대상자목록_" + kendo.toString(new Date(), "yyyyMMdd_HHmmss") + ".xlsx";
    const url = "/api/v2.2/elder";
    downloadExcel(pager, fileName, url, setLoading);
  };

  const phoneNumberFormat = (number) => {
    // const cleanedNumber = ('' + number).replace(/\D+/g, ''); // 숫자만 추출
    let formattedNumber
    if(number.length === 10) {
      formattedNumber = number.replace(/(\d{3})(\d{3})(\d{4})/, (match, p1, p2, p3, offset, string) => {
        if (p2) {
          if (p3) {
            return [p1, p2, p3].join('-');
          } else {
            return [p1, p2].join('-');
          }
        } else {
          return p1;
        }
      });
    } else {
      formattedNumber = number.replace(/(\d{3})(\d{4})(\d{4})/, (match, p1, p2, p3, offset, string) => {
        if (p2) {
          if (p3) {
            return [p1, p2, p3].join('-');
          } else {
            return [p1, p2].join('-');
          }
        } else {
          return p1;
        }
      });
    }
    return formattedNumber;
  }

  // 저장 이벤트
  const submitData = dataItem => {

    dataItem.userPhone = phoneNumberFormat(dataItem.userPhone);
    dataItem.protectorPhone = phoneNumberFormat(dataItem.protectorPhone);

    if(dataItem.bizType === "5003" && dataItem.imei) {
      // tbh_device_cmd 테이블에 데이터 추가
      insertDeviceData(conn, dataItem);
    }
    const validation = validationCheck(dataItem);
    if (validation.check === false) {
      kendo.alert(validation.message);
      return;
    }
    setElderInfo({ ...elderInfo, visible: false });
    setElder(dataItem);
  };

  // 저장 API
  const setElder = dataItem => {

    if(elderInfo.isNew) {
      setUserInsert(conn, dataItem)
        .then(response => {
          kendo.alert(dataItem.userTerm + " 대상자 등록완료");
          getElderList();
        })
        .catch(error => console.log("setUpdateElder Error", error));
    } else {
      setUserUpdate(conn, dataItem)
        .then(response => {
          kendo.alert(dataItem.userTerm + " 대상자 수정완료");
          getElderList();
        })
        .catch(error => console.log("setUpdateElder Error", error));
    }
    setElderInfo({
      visible: false,
      isNew: false,
      dataItem: {},
    });
  };

  /* --------------------------------------------------------------------- gridEvent  */
  // 필터
  // 읍면동 주소
  const rgnFilterDropDown = CustomFilter(
    dongList,
    { dongCode: "", dongTerm: "시/군/구" },
    "dongCode",
    "dongTerm",
    true,
    loginInfo.userTypeCode === 2002,
  );
  // 담당자 필터
  const managerFilterDropDown = CustomFilter(
    managerList,
    { userId: "", userTerm: "담당자" },
    "userId",
    "userTerm",
    true,
    loginInfo.userTypeCode === 2002,
  );

  // 그리드 페이징 처리
  const handlePageChange = e => {
    const { take, skip } = e.page;
    pager.skip = skip;
    pager.take = take;
    getElderList();
  };

  // 그리드 필터링 처리
  const handleFilterChange = e => {
    // 필터 값 설정
    const isFilter = e.filter.filters[0];
    if (isFilter.field === "cid") {
      pager.cid = isFilter.value;
    } else if (isFilter.field === "userTerm") {
      pager.userTerm = isFilter.value;
    } else if (isFilter.field === "dongCode") {
      pager.dongCode = isFilter.value.dongCode;
    } else if (isFilter.field === "managerTerm") {
      pager.managerId = isFilter.value.userId;
      // 전화번호와 담당자 번호 탐색 및 분리
    }
    pager.skip = 0
    pager.take = 20
    getElderList();
  };

  // 그리드 소팅 처리
  const handleSortChange = e => {
    const { sort } = e;
    pager.sort = sort;
    pager.sortStatus = sort;
    if (sort.length !== 0) {
      pager.sort = sort[0].field + "," + sort[0].dir;
    }
    getElderList();
  };

  // Validation Check
  const validationCheck = dataItem => {
    let message = "";
    let check = true;

    if (!dataItem.userId) {
      check = false;
      message = "대상자 ID를 작성하지 않았습니다. 대상자 ID를 작성 해주세요.";
    } else if (!dataItem.userTerm) {
      check = false;
      message = "대상자 성함을 작성하지 않았습니다. 대상자 이름을 작성 해주세요.";
    }
    // 연락처 없는 대상자도 있어서 validator 제거
    // else if (!dataItem.userPhone) {
    //   check = false;
    //   message = '대상자 연락처를 작성하지 않았습니다. 대상자 연락처를 작성 해주세요.';
    // }
    else if (!dataItem.rgnCode) {
      check = false;
      message = "대상자 지역을 선택하지 않았습니다. 시군구를 선택 해주세요.";
    } else if (!dataItem.dongCode) {
      check = false;
      message = "대상자 지역을 선택하지 않았습니다. 읍면동을 선택 해주세요.";
    } else if (!dataItem.managerId) {
      check = false;
      message = "담당자를 선택하지 않았습니다. 담당자를 선택 해주세요.";
    }

    if (!dataItem.lat) {
      message = "위도를 입력해 주시기 바랍니다.";
      check = false;
    } else {
      if (dataItem.lat < 32.765586 || dataItem.lat > 38.929936) {
        message = "입력된 위도 값이 잘못 되었습니다. 다시 한번 확인 하시고 입력해 주시기 바랍니다. (범위 : 32.765586 ~ 38.929936)";
        check = false;
      }
    }
    if (!dataItem.lng) {
      message = "경도를 입력해 주시기 바랍니다.";
      check = false;
    } else {
      if (dataItem.lng < 124.611705 || dataItem.lng > 131.729758) {
        message = "입력된 경도 값이 잘못 되었습니다. 다시 한번 확인 하시고 입력해 주시기 바랍니다. (범위 : 124.611705 ~ 131.729758)";
        check = false;
      }
    }

    // 새로운 계정 시
    if (elderInfo.isNew === true) {
    }

    return { check: check, message: message };
  };

  /* --------------------------------------------------------------------- gridCell  */
  // 셀 템플릿
  const managerTemplate = e => {
    const { dataItem, field } = e;
    const managerTerm = dataItem.managerTerm;
    const managerPhone = dataItem.managerPhone;
    return (
      <>
        <td>
          {managerTerm}
          <br />({managerPhone})
        </td>
      </>
    );
  };
  const protectorTemplate = e => {
    const { dataItem, field } = e;
    const protectorTerm = dataItem.protectorTerm;
    const protectorPhone = dataItem.protectorPhone;
    if (protectorTerm === null && protectorPhone === null) {
      return (
        <>
          <td>-</td>
        </>
      );
    } else if (protectorTerm !== null && protectorPhone === null) {
      return (
        <>
          <td>{protectorTerm}</td>
        </>
      );
    } else if (protectorTerm === null && protectorPhone !== null) {
      return (
        <>
          <td>{protectorPhone}</td>
        </>
      );
    } else {
      return (
        <>
          <td>
            {protectorTerm}
            <br />({protectorPhone})
          </td>
        </>
      );
    }
  };

  const brithdayCell = e => {
    const { dataItem } = e;
    let result = "";
    if (dataItem.birthday)
      result = dataItem.birthday.substring(0, 4) + "년 " + dataItem.birthday.substring(5, 7) + "월 " + dataItem.birthday.substring(8, 10) + "일";
    return <td>{result}</td>;
  };

  const installDtmCell = e => {
    const { dataItem } = e;
    let ymd = ""; //년월일
    let hms = ""; //시분초
    if (dataItem.installDtm) ymd = dataItem.installDtm.substring(0, 10);
    if (dataItem.installDtm) hms = dataItem.installDtm.substring(10, 19);
    return (
      <td>
        {ymd}
        <br />
        {hms}
      </td>
    );
  };
  const dongCell = e => {
    const { dataItem } = e;
    const result = dongList.find(item => item.dongCode === dataItem.dongCode);
    return (
      <td>
        {result ? (
          <>
            {result.dongTerm} {dataItem.address}
          </>
        ) : null}
      </td>
    );
  };

  const userPhoneCell = e => {
    const { dataItem } = e;
    return <td>{dataItem.userPhone ? dataItem.userPhone : "-"}</td>;
  };

  const sickTypeCell = e => {
    if (e.dataItem.sickType === null) {
      return <td>-</td>;
    } else {
      return <td>{e.dataItem.sickType}</td>;
    }
  };

  const noteCell = e => {
    if (e.dataItem.note === null || e.dataItem.note === "") {
      return <td>-</td>;
    } else {
      return <td>{e.dataItem.note}</td>;
    }
  };

  /* -------------------------------------------------------------- useEffect  */
  useEffect(() => {
    getElderList();
    getManagerList();
  }, []);

  /* -------------------------------------------------------------- return  */
  return (
    <div>
      <div>
        <Button className="buttonArea" onClick={addRowEvtBtn} icon="add">
          추가
        </Button>
        {/* <Button className="buttonArea" onClick={excelUploadEvtBtn} icon="file-bac">
          엑셀파일 가져오기
        </Button>
        <Button className="buttonArea" onClick={excelSampleEvtBtn} icon="download">
          엑셀샘플 다운로드
        </Button> */}
        <Button className="buttonArea" onClick={excelDownEvtBtn} icon="excel">
          엑셀저장
        </Button>
      </div>
      <div
        className={styles.gridArea}
        style={
          loading
            ? {
                opacity: 0.6,
                pointerEvents: "none",
                position: "relative",
              }
            : null
        }>
        <LocalizationProvider language="ko-KR">
          <IntlProvider locale="ko">
            <Grid
              className="elderListGrid"
              style={{ height: "100%" }}
              data={elderList}
              skip={pager.skip}
              take={pager.take}
              total={pager.total}
              sort={pager.sortStatus}
              pageable={{ buttonCount: 5, pageSizes: true }}
              sortable={true}
              filterable={true}
              onPageChange={handlePageChange}
              onFilterChange={handleFilterChange}
              onSortChange={handleSortChange}>
              <GridColumn field="cid" title="CID" filterCell={GridColumnInputFilter} width="120px" />
              <GridColumn field="userTerm" title="성함" filterCell={GridColumnInputFilter} width="100px" />
              <GridColumn field="birthday" title="생년월일" filterable={false} width="140px" cell={brithdayCell} />
              <GridColumn field="dongCode" title="주소" filterCell={rgnFilterDropDown} cell={dongCell} sortable={false} width="210px"/>
              <GridColumn field="userPhone" title="연락처" filterable={false} cell={userPhoneCell} width="130px" sortable={false} />
              <GridColumn
                field="managerTerm"
                title="담당자(연락처)"
                filterCell={managerFilterDropDown}
                cell={managerTemplate}
                width="130px"
                sortable={false}
              />
              <GridColumn field="protectorTerm" title="보호자(연락처)" filterable={false} cell={protectorTemplate} width="130px" sortable={false} />
              <GridColumn field="installDtm" title="설치일시" filterable={false} width="100px" cell={installDtmCell} />
              {/* <GridColumn field="sickType" title="보유지병" filterable={false} cell={sickTypeCell} width="160px" sortable={false} /> */}
              <GridColumn field="dangerYn" title="위험대상자" filterable={false} width="90px" sortable={false}/>
              <GridColumn field="absenceYn" title="장기부재" filterable={false} width="90px" sortable={false}/>
              <GridColumn field="locationYn" title="위치추적" filterable={false} width="90px" sortable={false}/>
              <GridColumn field="note" title="특이사항" filterable={false} cell={noteCell} sortable={false} />
              <GridColumn
                title="행동패턴"
                filterable={false}
                sortable={false}
                width={85}
                cell={props => (
                  <td>
                    <a
                      onClick={e => {
                        e.preventDefault();
                        isBehaviorBtn(props.dataItem);
                      }}>
                      <i>
                        <AccessTime />
                      </i>
                    </a>
                  </td>
                )}
              />
              <GridColumn
                title="보유지병"
                filterable={false}
                sortable={false}
                width={85}
                cell={props => (
                  <td>
                    <a
                      onClick={e => {
                        e.preventDefault();
                        isDiseaseBtn(props.dataItem);
                      }}>
                      <i>
                        <LocalHospital />
                      </i>
                    </a>
                  </td>
                )}
              />
              <GridColumn
                title="사진"
                filterable={false}
                sortable={false}
                width={60}
                cell={props => (
                  <td>
                    <a
                      onClick={e => {
                        e.preventDefault();
                        isPhotoBtn(props.dataItem);
                      }}>
                      <i>
                        <PhotoCamera />
                      </i>
                    </a>
                  </td>
                )}
              />
              <GridColumn
                title="수정"
                filterable={false}
                sortable={false}
                width={60}
                cell={props => (
                  <td>
                    <a
                      onClick={e => {
                        e.preventDefault();
                        isEditEvtBtn(props.dataItem);
                      }}>
                      <i>
                        <Create />
                      </i>
                    </a>
                  </td>
                )}
              />
              <GridColumn
                title="삭제"
                filterable={false}
                sortable={false}
                width={60}
                cell={props => (
                  <td>
                    <a
                      onClick={e => {
                        e.preventDefault();
                        isDeletedBtn(props.dataItem);
                      }}>
                      <i>
                        <Delete />
                      </i>
                    </a>
                  </td>
                )}
              />
              <GridNoRecords>데이터가 존재하지 않습니다.</GridNoRecords>
            </Grid>
            {loading && (
              <p
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%,-50%)",
                }}>
                <BeatLoader loading={true} size={24} color="#1e88e5" />
              </p>
            )}
          </IntlProvider>
        </LocalizationProvider>
        {elderInfo.visible === true && (
          <ElderInfo
            conn={conn}
            rgnList={rgnList}
            dongList={dongList}
            isNew={elderInfo.isNew}
            submitData={submitData}
            elderInfo={elderInfo}
            setElderInfo={setElderInfo}
            dataItem={elderInfo.dataItem}
            managerList={managerList}
          />
        )}
        {elderInfo.photoInfo === true && (
          <ElderPhoto
            conn={conn}
            rgnList={rgnList}
            dongList={dongList}
            isNew={elderInfo.isNew}
            submitData={submitData}
            elderInfo={elderInfo}
            setElderInfo={setElderInfo}
            dataItem={elderInfo.dataItem}
            managerList={managerList}
          />
        )}
        {elderInfo.behaviorInfo === true && (
          <ElderBehavior
            conn={conn}
            elderInfo={elderInfo}
            setElderInfo={setElderInfo}
          />
        )}
        {elderInfo.diseaseInfo === true && (
          <ElderDisease
            conn={conn}
            elderInfo={elderInfo}
            setElderInfo={setElderInfo}
          />
        )}
      </div>
    </div>
  );
};
export default ElderMngt;
